<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div>
    <label v-if="label" :class="$style.label" class="p1">{{ label }}</label>
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.label {
  display: block;
  margin-bottom: 13px;
}
</style>
